import * as React from 'react';
import {EventDto} from "../../event-details/dtos";
import locales from "../../locales";
import * as paths from "../../paths";
import {Link} from "react-router-dom";
import {MOMENT_DATE_FORMAT, MOMENT_DATE_TIME_FORMAT, MOMENT_TIME_FORMAT, now} from "../../utils/date-utils";
import {Button, Modal} from "antd";
import {toCombinedAddress} from "../../utils/form-utils";
import {ClientSummary, Contact} from "../../api/dtos/dtos";
import {renderEventTypeElement} from "../../client-calendar/EventType";
import ButtonBar from "../../common/ButtonBar";
import {showDeleteConfirm} from "../../utils/dialogs";
import {eventAlertStateToText} from "../../event-alerts/eventAlertState";

interface EventDetailsViewProps {
  event: EventDto;
  show: boolean;
  onClose: () => void;
  onEdit: (event: EventDto) => void;
  onDelete: (event: EventDto) => void;
}

class EventDetailsModal extends React.Component<EventDetailsViewProps, any> {

  public render(): React.ReactNode {
    const {show, onClose} = this.props;
    const {
      subject, client, contact, site, comment, start, end, type,
      alertDate, alertState, completed
    } = this.props.event;

    const time = `${start.format(MOMENT_DATE_FORMAT)} ${start.format(MOMENT_TIME_FORMAT)} - ${end.format(MOMENT_TIME_FORMAT)}`
    const isBeforeNow = now().isAfter(start);

    return (
      <Modal
        centered={true}
        title={subject}
        visible={show}
        onCancel={onClose}
        footer={[
          <ButtonBar key="buttons">
            <Button key="delete" onClick={this.onDelete} type="danger">
              {locales.delete}
            </Button>
            <Button key="edit" onClick={this.editEvent}>
              {locales.edit}
            </Button>,
          </ButtonBar>
        ]}
      >
        <table>
          <tbody>
          {this.row(locales.event_type, renderEventTypeElement(type))}
          {this.row(locales.event_date, time)}
          {this.row(locales.comment, comment)}

          {client && this.row(locales.client, this.renderClientName(client))}
          {client && this.row("", this.renderClientAddress(client))}

          {contact && this.row(locales.client_contact, this.contactName(contact))}
          {contact && this.row("", this.renderEmail(contact))}
          {contact && this.row("", this.renderPhone(contact))}

          {site && this.row(locales.event_location, site.address)}

          {alertDate && this.row(locales.event_alert_date, alertDate.format(MOMENT_DATE_TIME_FORMAT))}
          {alertState && this.row(locales.event_alert_state, eventAlertStateToText[alertState])}

          {isBeforeNow && this.row(locales.state, this.renderCompleted(completed))}
          </tbody>
        </table>
      </Modal>
    );
  }

  private row = (title: string, value: React.ReactNode) => {
    if (!value) {
      return null;
    }
    return (
      <tr>
        <td style={{textAlign: 'right', paddingRight: 12, paddingBottom: 4}}><b>{title}</b></td>
        <td style={{paddingBottom: 4}}>{value}</td>
      </tr>
    );
  };

  private contactName = (contact: Contact): React.ReactNode => {
    return (
      <span>{contact.name} <span style={{fontSize: 12, color: '#aaaaaa'}}>{contact.title}</span></span>
    )
  }

  private renderClientName = (client: ClientSummary): React.ReactNode => {
    return (
      <Link to={paths.viewClientPath(client.id)}>{client.name}</Link>
    );
  }

  private renderClientAddress = (client: ClientSummary): React.ReactNode => {
    const fullAddress = toCombinedAddress(client);
    return this.renderLink(
      `https://www.google.com/maps/search/?api=1&query=${fullAddress}`,
      fullAddress,
      locales.open_map,
    );
  }

  private renderEmail = (c: Contact): React.ReactNode => {
    if (c.email) {
      return this.renderLink(`mailto:${c.email}`, c.email, locales.send_email);
    }
    return null;
  }

  private renderPhone = (c: Contact): React.ReactNode => {
    if (c.tel) {
      return this.renderLink(`tel:${c.tel}`, c.tel, locales.initiate_call);
    }
    return null;
  }

  private renderLink = (href: string, text: string, title: string): React.ReactNode => {
    return (
      <a href={href} target="_blank" title={title}>{text}</a>
    );
  }

  private renderCompleted = (completed?: boolean): React.ReactNode => {
    return (
      completed ? locales.event_completed : locales.event_not_completed
    );
  }

  private editEvent = () => {
    this.props.onEdit(this.props.event);
  }

  private onDelete = () => {
    showDeleteConfirm(this.deleteEvent);
  };

  private deleteEvent = () => {
    this.props.onDelete(this.props.event);
  }
}

export default EventDetailsModal;


// WEBPACK FOOTER //
// ./src/event/view/EventDetailsModal.tsx